const agentcoreConfig = {
  region: "ap-northeast-1",
  runtimeArn: "arn:aws:bedrock-agentcore:ap-northeast-1:833248336673:runtime/IoTAiAgent_McpChat-kfdkwg92rR",
  identityPoolId: "ap-northeast-1:88309938-6757-48cb-bff2-c7f57c179227",
  userPoolId: "ap-northeast-1_VFb4QPsHu",
}
export default agentcoreConfig
